import { toSafeHref } from './links';

/**
 * A raster image as a base64 `data:` URI — the format the msgraph provider
 * stores (D-16). SVG is excluded: it can carry script.
 */
const RASTER_DATA_URI =
  /^data:image\/(?:jpeg|png|gif|webp);base64,[A-Za-z0-9+/]+={0,2}$/;

/**
 * The picture of a person for the stock Avatar (a squad member, the
 * signed-in user on Configurações) (SR-09 v2, AD-6 v4): an
 * `https` URL, or a raster `data:image/(jpeg|png|gif|webp);base64,` URI.
 * Anything else — `data:image/svg+xml`, other `data:` types, `http:`,
 * `javascript:` — gives none, and the initials are shown.
 */
export function memberPicture(picture: unknown): string | undefined {
  if (typeof picture === 'string' && RASTER_DATA_URI.test(picture)) {
    return picture;
  }
  const href = toSafeHref(picture);
  return href?.startsWith('https:') ? href : undefined;
}
